module.exports = __webpack_public_path__ + "static/media/industrial_1.88b84a91.jpg";